import { kind as startKind } from '../../actions/goals/Start';
import { reject } from '../../GoalResolvers';
import { State } from '../../State';
import { start } from './start';
import { suspend } from './suspend';

export function restart(state: State): State {
  const reason = 'Restarting';
  let goalResolvers = state.goalResolvers;
  goalResolvers = reject(goalResolvers, startKind, reason);

  if (state.replication) {
    return suspend({
      ...state,
      goalResolvers,
    });
  }

  return start(state);
}
